
function Filtro(props) {
  return (
      <div className="filtro">
        <label>{props.name || props.id }</label>
        <select id={props.id} onChange={props.onChange} value={props?.value}>
          {getOptions(props.data)}
        </select>
      </div>
  )
}

const getOptions = (data)=> {
  return data.map(x=> {
    return (<option key={x.value} value={x.value}>{x.label}</option>)
  })
}

export default Filtro;
